module.exports = __webpack_public_path__ + "img/arrow-left-blue.ef6f0e3b.svg";